export default "__VITE_ASSET__k_0I0Te2__"